import type { Theme } from '@mui/material/styles';

const Badge = (theme: Theme) => {
  return {
    MuiBadge: {
      styleOverrides: {
        dot: {
          borderRadius: '50%',
          height: 10,
          width: 10,
        },
      },
    },
  };
};

export default Badge;
